import { Injectable } from '@angular/core';
import { AbpHttpConfigurationService, IErrorInfo, LogService, MessageService } from 'abp-ng2-module';
import { Router } from '@angular/router';
import { GeocodingApiErrorContextService } from './geocoding-api-error-context.service';

@Injectable({
    providedIn: 'root'
})
export class ZeroTemplateHttpConfigurationService extends AbpHttpConfigurationService {

    constructor(
        messageService: MessageService,
        logService: LogService,
        private _route: Router,
        private _geocodingApiErrorContext: GeocodingApiErrorContextService) {
        super(messageService, logService);
    }

    showError(error: IErrorInfo): any {
        if (this._geocodingApiErrorContext.consumeSuppression()) {
            this.logError(error);
            return;
        }

        return super.showError(error);
    }

    // Override handleUnAuthorizedRequest so it doesn't refresh the page during failed login attempts.
    handleUnAuthorizedRequest(messagePromise: any, targetUrl?: string) {
        if (this._route.url === '/account/login') {
            return;
        }

        const self = this;

        if (messagePromise) {
            messagePromise.done(() => {
                this.handleTargetUrl(targetUrl || '/');
            });
        } else {
            self.handleTargetUrl(targetUrl || '/');
        }
    }
}
